module.exports = __webpack_public_path__ + "img/icone-coffee-beans.2b9cdf8b.svg";